module.exports = __webpack_public_path__ + "img/guaz.57d7177b.png";